import { MapPin, Clock, Mail, Phone, Navigation, ClipboardList } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/scroll";
import { BUSINESS } from "../constants/business";

export const ContactSection = () => (
  <section id="contact" className="px-6 md:px-12 lg:px-24 py-24 md:py-32 bg-[#0A0A0A]" data-testid="contact-section">
    <Reveal>
      <p className="text-[#FF3B30] text-xs uppercase tracking-[0.35em] font-semibold mb-4">09 — Contact</p>
      <h2 className="font-oswald font-bold uppercase tracking-tight text-4xl sm:text-5xl leading-[1.02]" data-testid="contact-heading">
        Find Us in <span className="text-zinc-500">Oklahoma City.</span>
      </h2>
    </Reveal>

    <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-10">
      <Reveal>
        <div className="border border-zinc-800 bg-zinc-900/40 p-8 md:p-10 h-full flex flex-col">
          <img src="/logo.png" alt="Ascencio Auto Repair — official logo" className="h-14 w-auto mb-6 self-start" draggable="false" data-testid="contact-logo" />
          <h3 className="font-oswald uppercase tracking-tight text-3xl" data-testid="contact-business-name">{BUSINESS.name}</h3>
          <address className="not-italic mt-6 space-y-4 text-zinc-300 text-base">
            <p className="flex items-start gap-3" data-testid="contact-address">
              <MapPin className="w-5 h-5 text-[#FF3B30] shrink-0 mt-0.5" strokeWidth={1.5} />
              <span>{BUSINESS.street}<br />{BUSINESS.city}</span>
            </p>
            <p className="flex items-start gap-3" data-testid="contact-hours">
              <Clock className="w-5 h-5 text-[#FF3B30] shrink-0 mt-0.5" strokeWidth={1.5} />
              <span>{BUSINESS.hoursDays}<br />{BUSINESS.hoursTime}</span>
            </p>
            <p className="flex items-center gap-3">
              <Phone className="w-5 h-5 text-[#FF3B30] shrink-0" strokeWidth={1.5} />
              <a href={BUSINESS.phoneHref} className="hover:text-[#FF3B30] transition-colors duration-200" data-testid="contact-phone-link">
                {BUSINESS.phone}
              </a>
            </p>
            <p className="flex items-center gap-3">
              <Mail className="w-5 h-5 text-[#FF3B30] shrink-0" strokeWidth={1.5} />
              <a href={`mailto:${BUSINESS.email}`} className="hover:text-[#FF3B30] transition-colors duration-200 break-all" data-testid="contact-email-link">
                {BUSINESS.email}
              </a>
            </p>
          </address>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3">
            <a
              href={BUSINESS.phoneHref}
              data-testid="contact-call-btn"
              className="flex items-center justify-center gap-2 bg-[#FF3B30] text-white font-oswald uppercase tracking-[0.15em] text-sm px-4 py-4 hover:bg-white hover:text-black transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none"
            >
              <Phone className="w-4 h-4" /> Call
            </a>
            <a
              href={BUSINESS.directions}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-directions-btn"
              className="flex items-center justify-center gap-2 border border-zinc-600 text-white font-oswald uppercase tracking-[0.15em] text-sm px-4 py-4 hover:border-[#FF3B30] hover:text-[#FF3B30] transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-[#FF3B30] focus-visible:outline-none"
            >
              <Navigation className="w-4 h-4" /> Get Directions
            </a>
            <button
              onClick={() => scrollToId("request")}
              data-testid="contact-request-btn"
              className="flex items-center justify-center gap-2 border border-zinc-600 text-white font-oswald uppercase tracking-[0.15em] text-sm px-4 py-4 hover:border-[#FF3B30] hover:text-[#FF3B30] transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-[#FF3B30] focus-visible:outline-none"
            >
              <ClipboardList className="w-4 h-4" /> Request Service
            </button>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="border border-zinc-800 h-[360px] lg:h-full min-h-[360px] map-grayscale" data-testid="contact-map">
          <iframe
            title="Ascencio Auto Repair location map — 217 S Alliance Ct, Oklahoma City, OK 73128"
            src={BUSINESS.mapEmbed}
            className="w-full h-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </Reveal>
    </div>
  </section>
);
